import type { SimpleCommandType } from '@bioforge/game-core';

/** Раскладка по умолчанию (SPEC.md, раздел 9). Используются физические коды клавиш. */
export const DEFAULT_KEYMAP: Readonly<Record<string, SimpleCommandType>> = {
  ArrowLeft: 'move-left',
  ArrowRight: 'move-right',
  ArrowDown: 'soft-drop',
  Space: 'hard-drop',
  KeyX: 'rotate-clockwise',
  ArrowUp: 'rotate-clockwise',
  KeyZ: 'rotate-counterclockwise',
};

/** Не перехватываем клавиши, когда пользователь вводит текст. */
export function isTextInput(target: EventTarget | null): boolean {
  if (typeof HTMLElement === 'undefined' || !(target instanceof HTMLElement)) {
    return false;
  }
  return target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName);
}

export function keyToCommand(
  code: string,
  keymap: Readonly<Record<string, SimpleCommandType>> = DEFAULT_KEYMAP,
): SimpleCommandType | null {
  return keymap[code] ?? null;
}

/** Клавиши способностей: C — слот 0, V — слот 1 (SPEC.md, раздел 15.2). */
export const ABILITY_KEYS: Readonly<Record<string, number>> = { KeyC: 0, KeyV: 1 };

export function keyToAbilitySlot(
  code: string,
  keys: Readonly<Record<string, number>> = ABILITY_KEYS,
): number | null {
  return keys[code] ?? null;
}
